import React from 'react';
import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';

import { COLORS } from '../../../../constants/styles';

import styles from '../index.styl';

const SVGCheckbox = ({ checked, size }) => {
  const borderRadius = 2;
  const strokeWidth = 1;
  const innerSize = size - strokeWidth * 2;

  const width = innerSize;
  const height = innerSize;

  const rx = borderRadius;
  const ry = borderRadius;
  const x = strokeWidth;
  const y = strokeWidth;

  const startPoint = `${width * 0.3},${height * 0.6}`;
  const midPoint = `${width * 0.55},${height * 0.8}`;
  const stopPoint = `${width * 0.9},${height * 0.4}`;

  const checkPath = `${startPoint} ${midPoint} ${stopPoint}`;

  return (
    <svg
      width={size}
      height={size}
      styleName={checked ? 'checked' : 'unchecked'}
      className="db"
    >
      <rect
        {...{ x, y, rx, ry, width, height, strokeWidth }}
        stroke={checked ? COLORS.blueMedium : COLORS.fontLighter}
        fill="white"
      />
      <If condition={checked}>
        <polyline
          fill="none"
          stroke={COLORS.blueMedium}
          strokeWidth={strokeWidth * 2}
          strokeLinecap="round"
          strokeMiterlimit="10"
          points={checkPath}
        />
      </If>
    </svg>
  );
};

SVGCheckbox.propTypes = {
  checked: PropTypes.bool,
  size: PropTypes.number,
};

SVGCheckbox.defaultProps = {
  checked: false,
  size: 0,
};

export default CSSModules(SVGCheckbox, styles, { allowMultiple: true });



// WEBPACK FOOTER //
// ./src/components/common/Checkbox/SVGCheckbox/index.jsx